import React from "react"
import parse from "html-react-parser"

const TestimonialCard = props => {
  const { testimonial, content, title, blockClassName, blockDetailsClassName } =
    props

  return (
    <blockquote className={blockClassName}>
      <p>{parse(content)}</p>

      <div className={blockDetailsClassName}>
        <div className="info ps-0">
          <h5 className="mb-1">{testimonial.testimonialAuthor}</h5>
          <p className="mb-0">{title}</p>
        </div>
      </div>
    </blockquote>
  )
}

// set default props
TestimonialCard.defaultProps = {
  blockClassName: "icon icon-top fs-lg text-center",
  blockDetailsClassName:
    "blockquote-details justify-content-center text-center",
}

export default TestimonialCard
